<section
  class="sub-header small"
  [ngStyle]="{ 'background-image': getMenuBackgroundUrl() }"
>
  <!-- <h2>{{ getLayoutTitle() | translate }}</h2> -->
  <span class="desc">{{ '한민족 네트워크의 중심' | translate }}</span>
</section>
